module.exports = __webpack_public_path__ + "img/ys-detail.1202a70c.jpg";